import { render } from "./ControleCobrancasGarantePayView.vue?vue&type=template&id=222bd7fc&scoped=true"
import script from "./ControleCobrancasGarantePayView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasGarantePayView.vue?vue&type=script&lang=js"

import "./ControleCobrancasGarantePayView.vue?vue&type=style&index=0&id=222bd7fc&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222bd7fc"]])

export default __exports__